__webpack_require__.p = "https://bmidxbindonesiaplpreprod.netlify.app/";